<template>
    <vx-card title="Emergency Interwarehouse Stock Movement">
        <div class="flex md:flex-row">
            <div class="w-full pr-6 md:basis-1/2">
                <h4>Document's Details</h4>
                <hr>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span>Inter Warehouse Document</span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <vs-input
                            type="text"
                            v-model="code"
                            class="w-full"
                        />
                    </div>
                </div>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span>Movement Operation</span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <vs-input
                            type="text"
                            v-model="movementOperation"
                            class="w-full"
                        />
                    </div>
                </div>
            </div>
            <div class="w-full md:basis-1/2">
                <div class="w-full pr-6 md:basis-1/2">
                    <h4>Key Password</h4>
                    <hr>
                    <div class="mb-6 vx-row pt-2">
                        <div class="flex items-center w-full vx-col sm:w-1/3">
                            <span>Input Password</span>
                        </div>
                        <div class="w-full vx-col sm:w-2/3">
                            <vs-input
                                type="text"
                                v-model="thePassword"
                                class="w-full"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="vx-col sm:w-1/1 w-full mb-8">
            <div style="
                position: absolute;
                left: 50%;
                -ms-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
            ">
                <vs-button class="mr-3 mb-2" @click="handleUnreserve()">Unreserve</vs-button>
                <vs-button class="mr-3 mb-2" @click="handleMovement()">Movement</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>
export default {
    components: {
        // 
    },
    data() {
        return {
            thePassword: "",
            code: "",
            movementOperation: "",
        }
    },
    mounted() {
        // 
    },
    methods: {
        handleUnreserve() {
            if (this.thePassword == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank key password",
                    text: "Please fill the password",
                });
                return false;
            }

            if (this.code == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank document code",
                    text: "Please fill document code",
                });
                return false;
            }

            let params = {
                password: this.thePassword,
                code: this.code,
                operation: "unreserve",
            }

            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to unreserve this document?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post("/api/wms/v1/outbound/simple-sto/emergency-movement", params)
                    .then(resp => {
                        if (resp.code == 200) {
                            console.log("unreserved")
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "success",
                                title: "Unreserve data",
                                text: resp.message,
                            })
                        } else {
                            console.log("error unreserved => ", resp.message)
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: resp.message,
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    });
                }
            });
        },
        handleMovement() {
            if (this.thePassword == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank key password",
                    text: "Please fill the password",
                });
                return false;
            }

            if (this.code == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank document code",
                    text: "Please fill document code",
                });
                return false;
            }

            if (this.movementOperation == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank Movement Operation",
                    text: "Please fill Movement Operation name",
                });
                return false;
            }

            let params = {
                password: this.thePassword,
                code: this.code,
                movement_operation: this.movementOperation,
                operation: "stock-movement",
            }

            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to force movement stock this document?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post("/api/wms/v1/outbound/simple-sto/emergency-movement", params)
                    .then(resp => {
                        if (resp.code == 200) {
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "success",
                                title: "Stock movement",
                                text: resp.message,
                            })
                        } else {
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: resp.message,
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    });
                }
            });
        }
    }
}
</script>